import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import MiniCartQuantity from "../mini-cart/mini-cart-content/mini-cart-quantity";
import fetchProduct from "../helpers/useProduct/fetchProduct";
import formatDatalayerEcommerce from "../helpers/formatDatalayerEcommerce";

export default function SwatchProductActions({
  item,
  limitEach,
  onError = () => {},
  onAfterAdd = () => {},
  onAfterRemove = () => {},
  classPrefix,
  variantId,
  productGid,
  removeButtonClasses,
  addButtonClasses,
  addToCartText,
  removeFromCartText,
  swatchType,
  showWarning,
  removeAction,
  isQuickView = false,
}) {
  const [loading, setLoading] = useState(false);

  const handleAtcClick = () => {
    setLoading(true);

    if (productGid) {
      fetchProduct(productGid).then((product) => {
        const variant = product.variants.find(
          (variant) =>
            variant.id === `gid://shopify/ProductVariant/${variantId}`,
        );

        const customProperties = {
          is_quick_view: isQuickView,
          is_product_set: false,
          is_buy_now_button: false,
          quantity: 1,
        };

        const ecommerce = formatDatalayerEcommerce({
          product: product,
          variant,
          key: "add",
          customProperties,
        });

        window.ElevarDataLayer?.push({
          event: "dl_add_to_cart",
          ...ecommerce,
        });
      });
    }

    window.addToCart(
      {
        id: variantId,
        quantity: 1,
        properties: {
          _is_swatch: "true",
          _swatch_type: swatchType,
        },
      },
      {
        onError: () => {
          onError();
          setLoading(false);
        },
        onAfterAdd: () => {
          onAfterAdd();
          setLoading(false);
        },
      },
    );
  };

  const handleRemoveClick = () => {
    if (removeAction) {
      removeAction();
      return;
    }

    setLoading(true);
    window.updateCart(
      { updates: { [item.id]: 0 } },
      {
        onError: () => {
          onError();
          setLoading(false);
        },
        onAfterAdd: () => {
          onAfterRemove();
          setLoading(false);
        },
      },
    );
  };

  return (
    <>
      <div className={`${classPrefix}__product-actions`}>
        {item && limitEach > 1 && (
          <MiniCartQuantity item={item} max={limitEach} />
        )}
        {item ? (
          <button
            type="button"
            className={`${removeButtonClasses} ${classPrefix}__remove`}
            onClick={handleRemoveClick}
          >
            {loading
              ? window.localeStrings.product.removing_from_cart
              : removeFromCartText}
          </button>
        ) : (
          <button
            type="button"
            className={`${addButtonClasses} ${classPrefix}__add-to-cart`}
            onClick={handleAtcClick}
          >
            {loading
              ? window.localeStrings.product.adding_to_cart
              : addToCartText}
          </button>
        )}
      </div>
    </>
  );
}
